import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hub from "@/pages/Hub";
import Report from "@/pages/Report";
import BusinessReport from "@/pages/BusinessReport";
import OperationsReport from "@/pages/OperationsReport";
import AccessGate from "@/components/AccessGate";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AccessGate>
                    <Routes>
                        <Route path="/" element={<Hub />} />
                        <Route path="/product-it" element={<Report />} />
                        <Route path="/business" element={<BusinessReport />} />
                        <Route path="/operations" element={<OperationsReport />} />
                    </Routes>
                </AccessGate>
            </BrowserRouter>
        </div>
    );
}

export default App;
